import { Form, Input } from 'rsuite';
import React, { useState, useEffect, forwardRef } from 'react';
import SubHeader from 'components/Elements/Header/Header';
import { HStack, VStack } from '@urbantxt/layout';
import clsx from 'clsx';
import layoutStyles from 'components/Form/FormFieldLayout.module.scss';
import FormControlLabel from '../../Control/FormControlLabel';

export type Activity = {
  name: string;
  position: string;
  hours: string;
  grade: string;
};

type ActivitiesInputControlProps = {
  value: Activity[];
  onChange: any;
};

type ActivityItemProps = {
  rowValue: Activity;
  onChange: any;
  rowIndex: number;
};

function ActivityItem({
  rowValue,
  onChange,
  rowIndex,
}: ActivityItemProps) {
  const handleChangeName = (value: string) => {
    onChange(rowIndex, { ...rowValue, name: value });
  };
  const handleChangePosition = (value: string) => {
    onChange(rowIndex, { ...rowValue, position: value });
  };
  const handleChangeHours = (value: string) => {
    onChange(rowIndex, { ...rowValue, hours: value });
  };

  const handleChangeGrade = (value: string) => {
    onChange(rowIndex, { ...rowValue, grade: value });
  };

  return (
    <VStack marginBottom={35}>
      <SubHeader marginBottom={15}>{`${rowIndex + 1}`}.</SubHeader>
      <HStack fullWidth marginBottom={15} gap={35}>
        <div className={layoutStyles.fieldWrap}>
          <div className={layoutStyles.field}>
            <FormControlLabel>
              Club/Organization/Company/Sports
            </FormControlLabel>
            <div className={layoutStyles.controlWrapper}>
              <Input value={rowValue.name} onChange={handleChangeName} />
            </div>
          </div>
          <div className={layoutStyles.field}>
            <FormControlLabel>Position Held</FormControlLabel>
            <div className={layoutStyles.controlWrapper}>
              <Input
                value={rowValue.position}
                onChange={handleChangePosition}
              />
            </div>
          </div>
        </div>
      </HStack>
      <HStack fullWidth gap={35}>
        <div className={layoutStyles.fieldWrap}>
          <div className={layoutStyles.field}>
            <FormControlLabel>Hrs Per Week</FormControlLabel>
            <div className={layoutStyles.controlWrapper}>
              {' '}
              <Input value={rowValue.hours} onChange={handleChangeHours} />
            </div>
          </div>
          <div className={layoutStyles.field}>
            <FormControlLabel>Grade Level</FormControlLabel>
            <div className={layoutStyles.controlWrapper}>
              {' '}
              <Input value={rowValue.grade} onChange={handleChangeGrade} />
            </div>
          </div>
        </div>
      </HStack>
    </VStack>
  );
}

function ActivitiesInputControl({
  value,
  onChange,
}: ActivitiesInputControlProps) {
  const [activities, setActivities] = useState<Activity[]>(value);

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      if (value.length === 0) {
        setActivities([{ name: '', position: '', grade: '', hours: '' }]);
      } else {
        setActivities(value);
      }
    }
    return () => {
      mounted = false;
    };
  }, [value]);

  const handleChangeProducts = (nextActivities: Activity[]) => {
    setActivities(nextActivities);
    onChange(nextActivities);
  };

  const handleInputChange = (rowIndex: number, val: Activity) => {
    const nextActivities = [...activities];
    nextActivities[rowIndex] = val;
    handleChangeProducts(nextActivities);
  };

  return (
    <div>
      {activities.map((rowValue, index) => (
        <ActivityItem
          key={index}
          rowIndex={index}
          rowValue={rowValue}
          onChange={handleInputChange}
        />
      ))}

      <button
        type="button"
        className={layoutStyles.addButton}
        onClick={() => {
          setActivities([
            ...activities,
            { name: '', position: '', grade: '', hours: '' },
          ]);
        }}
      >
        <p>Add Extra Curricular</p>
      </button>
    </div>
  );
}

const ActivitiesFields = forwardRef((props: any, ref: any) => {
  const { name, size, helpMessage, label } = props;

  return (
    <Form.Group
      ref={ref}
      className={clsx(
        layoutStyles.formGroup,
        size === 'sm' && layoutStyles.formGroupSm,
      )}
    >
      <FormControlLabel>{label} </FormControlLabel>
      <div className={layoutStyles.controlWrapper}>
        <Form.Control name={name} accepter={ActivitiesInputControl} />
        {helpMessage ? <Form.HelpText>{helpMessage}</Form.HelpText> : null}
      </div>
    </Form.Group>
  );
});

export default ActivitiesFields;
